@if (snackbarStore.messages().length) {
  <section class="snackbar-host" aria-label="Notificações rápidas">
    @for (message of snackbarStore.messages(); track message.id) {
      <lib-ui-snackbar-item
        [message]="message"
        (dismissed)="dismiss($event)"
      ></lib-ui-snackbar-item>
    }
  </section>
}
